// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"99767a94","453":"945e70c7","553":"bb64cb11"}[chunkId] + ".chunk.js";
};